import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Menu, X, Sparkles, Coins } from "lucide-react";
import { useState } from "react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [open, setOpen] = useState(false);

  const links = [
    { to: "/", label: "Accueil" },
    { to: "/pricing", label: "Tarifs" },
    { to: "/blog", label: "Blog" },
    { to: "/faq", label: "FAQ" },
    { to: "/contact", label: "Contact" },
  ];

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#050505]/80 border-b border-white/5">
      <nav className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between" aria-label="Navigation principale">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo" aria-label="VisionAI Studio, retour à l'accueil">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-indigo-500 to-cyan-400 flex items-center justify-center">
            <Sparkles className="w-4 h-4 text-white" />
          </div>
          <span className="font-display font-bold text-lg tracking-tight">VisionAI Studio</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={`text-sm transition-colors ${loc.pathname === l.to ? "text-white" : "text-white/60 hover:text-white"}`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10">
                <Coins className="w-3.5 h-3.5 text-cyan-400" />
                <span data-testid="nav-credits" className="text-sm font-mono">{user.credits}</span>
              </div>
              <Link to="/dashboard" data-testid="nav-dashboard" className="text-sm text-white/70 hover:text-white">Dashboard</Link>
              <Link to="/profile" data-testid="nav-profile" className="text-sm text-white/70 hover:text-white">Profil</Link>
              {user.role === "admin" && (
                <Link to="/admin" data-testid="nav-admin" className="text-sm text-cyan-400 hover:text-cyan-300">Admin</Link>
              )}
              <button
                onClick={async () => { await logout(); nav("/"); }}
                data-testid="nav-logout"
                className="text-sm px-4 py-2 rounded-full border border-white/10 hover:bg-white/5 transition-colors"
              >
                Déconnexion
              </button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login" className="text-sm text-white/70 hover:text-white">Connexion</Link>
              <Link to="/register" data-testid="nav-cta" className="text-sm px-5 py-2 rounded-full bg-indigo-600 hover:bg-indigo-500 btn-glow font-medium">Commencer gratuitement</Link>
            </>
          )}
        </div>

        <button className="md:hidden focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 rounded p-1" onClick={() => setOpen(!open)} data-testid="nav-toggle" aria-label={open ? "Fermer le menu" : "Ouvrir le menu"} aria-expanded={open} aria-controls="mobile-menu">
          {open ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
        </button>
      </nav>

      {open && (
        <div id="mobile-menu" className="md:hidden border-t border-white/5 px-6 py-4 space-y-3 bg-[#050505]">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="block text-white/70 hover:text-white">{l.label}</Link>
          ))}
          {user ? (
            <>
              <Link to="/dashboard" onClick={() => setOpen(false)} className="block text-white/70">Dashboard ({user.credits} crédits)</Link>
              <button onClick={async () => { await logout(); nav("/"); }} className="text-white/70">Déconnexion</button>
            </>
          ) : (
            <>
              <Link to="/login" onClick={() => setOpen(false)} className="block text-white/70">Connexion</Link>
              <Link to="/register" onClick={() => setOpen(false)} className="block text-cyan-400">Commencer gratuitement</Link>
            </>
          )}
        </div>
      )}
    </header>
  );
}
